import { render, staticRenderFns } from "./DisplayRow.vue?vue&type=template&id=0ec59d37"
import script from "./DisplayRow.vue?vue&type=script&lang=js"
export * from "./DisplayRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports